import React from 'react';
import Select from 'react-select';


export default class ProgramsForm extends React.Component {

	constructor(props) {
		super(props);
		this.programsState = props.programsState;
	}

	render() {

		return (
			<form id="programs-form" className="programs-form__filters dark-theme" action="">
				<div className="programs-form__filter-facet programs-form__facet--audience">
					<label className="programs-form__filter-label">Audiences</label>
					<div className="programs-form__filter-select custom-select">
						<Select
							fieldName="audiences"
							isMulti={true}
							className="education-select"
							maxMenuHeight={500}
							options={this.programsState.form.choices.audiences}
							value={this.programsState.form.data.audiences}
							onChange={(value) => this.programsState.form.onSelectFieldChange(this.programsState.form, 'audiences', value)}
						/>
					</div>
				</div>
				<div className="programs-form__filter-facet programs-form__facet--date">
					<label className="programs-form__filter-label">Types</label>
					<div className="programs-form__filter-select custom-select">
							<Select
							fieldName="resource_types"
							isMulti={true}
							className="education-select"
							maxMenuHeight={500}
							options={this.programsState.form.choices.resource_types}
							value={this.programsState.form.data.resource_types}
							onChange={(value) => this.programsState.form.onSelectFieldChange(this.programsState.form, 'resource_types', value)}
						/>				</div>
				</div>
				<div className="programs-form__filter-facet programs-form__facet--type">
					<label className="programs-form__filter-label">Learning areas</label>
					<div className="programs-form__filter-select custom-select">
						<Select
							fieldName="curriculum_areas"
							isMulti={true}
							className="education-select"
							maxMenuHeight={500}
							options={this.programsState.form.choices.curriculum_areas}
							value={this.programsState.form.data.curriculum_areas}
							onChange={(value) => this.programsState.form.onSelectFieldChange(this.programsState.form, 'curriculum_areas', value)}
						/>
					</div>
				</div>
			</form>
		);
	}
}
